import { Container } from "@mui/material";
import { isNil } from "lodash";
import { useMemo } from "react";
import Flx from "../../../components/layout/Flx";
import Htag from "../../../components/typography/Htag";
import Txt from "../../../components/typography/Txt";
import {
  LOAN_TAB_MAX_WIDTH,
  LOAN_TAB_PX,
  LOAN_TAB_PY,
} from "../shared/tabLayout/loanTabLayoutTokens";

// NOTE: the newer `LoanTabShell` (shared/tabLayout) supersedes this wrapper —
// it renders the same container geometry plus the shared `LoanTabHeader`. Both
// read their width/padding from `loanTabLayoutTokens`, so tabs on either one
// stay aligned. Prefer LoanTabShell for new tabs.
const LoanDrilldownTabContentWrapper = ({
  value,
  tab,
  children,
  maxWidth = LOAN_TAB_MAX_WIDTH,
  sx,
  endContent,
  title,
  subTitle,
  titleSx,
  py = LOAN_TAB_PY,
  px = LOAN_TAB_PX,
  titleEndContent,
  bodyGap = 0,
  containerStartContent,
  bodyMargin = 4,
  titleBottomContent,
}) => {
  if (isNil(title)) {
    return children;
  }

  return (
    <Container maxWidth={maxWidth} sx={{ py, px, ...sx }}>
      {containerStartContent}
      {title && (
        <SectionHeader
          title={title}
          subTitle={subTitle}
          titleSx={titleSx}
          titleEndContent={titleEndContent}
          endContent={endContent}
        />
      )}
      {titleBottomContent}
      <Flx column gap={bodyGap} sx={{ mt: bodyMargin }}>
        {children}
      </Flx>
    </Container>
  );
};
const SectionHeader = ({
  title,
  subTitle,
  sx,
  titleSx,
  titleEndContent,
  hideTitle,
  endContent,
  expanded,
  expandedable,
  onExpandClick,
}) => {
  const rootStyles = useMemo(() => {
    return {
      ...sx,
      mb: 1,
    };
  }, [sx]);
  if (isNil(title)) return null;
  return (
    <Flx wrap gap={2} fw jb ac sx={rootStyles}>
      <Flx column gap={0.5}>
        {hideTitle ? null : (
          <Flx ac g={1}>
            <Htag sx={titleSx}>{title}</Htag>
            {titleEndContent}
          </Flx>
        )}
        {subTitle && <Txt secondary>{subTitle}</Txt>}
      </Flx>
      <Flx ac>{endContent}</Flx>
    </Flx>
  );
};
export default LoanDrilldownTabContentWrapper;
